import React from 'react';
import './AppBrandInline.css';

const MARK_SRC = `${process.env.PUBLIC_URL}/plan-to-go-logo-only.png`;
const LOGO_SRC = `${process.env.PUBLIC_URL}/plangonow.-logo.png`;

/**
 * Wordmark + ikona z pliku w public/ - używane w Headerze i na LandingPage.
 */
function AppBrandInline() {
  return (
    <span className="app-brand-inline">
      <img
        src={MARK_SRC}
        alt=""
        className="app-brand-mark-img"
        draggable={false}
      />
      <img
        src={LOGO_SRC}
        alt="Plan Go Now"
        className="app-brand-logo-img"
        draggable={false}
      />
      <span className="app-brand-beta">Beta</span>
    </span>
  );
}

export default AppBrandInline;
